module.exports = __webpack_public_path__ + "static/media/bullet_red.e1509620.svg";